import React from "react";
import CurrentDate from "../general/CurrentDate";
import ReactDatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.module.css';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { getSlidingYearRange } from "../../utils/sequencesfunction";
import { Upload, Calendar, FileText, MessageSquare, ChevronLeft, FolderOpen, ChevronRight } from 'lucide-react';

function InfoEval({ handleSubjectFileChange, comments, handleNext, title, handleTitleChange, handleCommentsChange, evalDate, handleDateChange, niveau }) {

  const { idclasse } = useParams();
  const navigate = useNavigate();
  // États existants SANS CHANGEMENT
  const [dateError, setDateError] = useState('');
  const [subjectFile, setSubjectFile] = useState(null);
  const [correctionFile, setCorrectionFile] = useState(null);
  const [dateRange, setDateRange] = useState({ min: '', max: '' });

  // Fonctions existantes SANS CHANGEMENT
  const handleBack = () => {
    if (idclasse) {
      // Flux standard : on revient au hub Créer (point d'entrée de « J'ai déjà
      // mon sujet »), pas à la liste des évaluations.
      navigate(`/home/creer/${idclasse}`);
    } else {
      navigate('/home/common-eval')
    }
  };

  useEffect(() => {
    const loadRange = async () => {
      const { min, max } = await getSlidingYearRange();
      setDateRange({ min, max });
    };
    loadRange();
  }, []);

  const handleSubjectChange = (event) => {
    const file = event.target.files[0];
    setSubjectFile(file);
    handleSubjectFileChange(event);
  };

  const handleCorrectionChange = (event) => {
    const file = event.target.files[0];
    setCorrectionFile(file);
  };

  const handleDateValidation = (event) => {
    const newDate = event.target.value;

    if (newDate && dateRange.min && dateRange.max) {
      const inputDate = new Date(newDate);
      const minDate = new Date(dateRange.min);
      const maxDate = new Date(dateRange.max);

      if (inputDate < minDate || inputDate > maxDate) {
        setDateError(`⚠️ La date doit être entre le ${new Date(dateRange.min).toLocaleDateString('fr-FR')} et le ${new Date(dateRange.max).toLocaleDateString('fr-FR')}`);
      } else {
        setDateError('');
      }
    } else {
      setDateError('');
    }

    handleDateChange(event);
  };

  return (
    <div className="flex">
      <div className="w-full max-w-6xl mx-auto bg-white/95 backdrop-blur-xl rounded-2xl sm:rounded-3xl shadow-2xl overflow-hidden border border-white/20">
        {/* Header responsive */}
        <div className="bg-gradient-to-r from-blue-500 to-sky-600 text-white text-center py-4 sm:py-6 lg:py-8 xl:py-4 2xl:py-5 3xl:py-8 px-4 sm:px-6 lg:px-10 xl:px-5 2xl:px-7 3xl:px-10 relative overflow-hidden">
          <div className="absolute -top-16 -right-16 w-24 sm:w-32 h-24 sm:h-32 bg-white/10 rounded-full"></div>
          <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-lg 2xl:text-xl 3xl:text-3xl font-bold mb-1 sm:mb-2 relative z-10">
            {/* Titre conditionnel : devoir commun (niveau) garde « Créer une Évaluation » ;
                le flux standard arrive depuis la carte « J'ai déjà mon sujet » du hub. */}
            <span className="hidden sm:inline">{niveau ? "Créer une Évaluation" : "Renseigner mon évaluation"}</span>
            <span className="sm:hidden">{niveau ? "Nouvelle Évaluation" : "Mon évaluation"}</span>
          </h1>
          <p className="text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg opacity-90 relative z-10">
            {new Date().toLocaleDateString('fr-FR')}
          </p>
        </div>

        {/* Section Upload - Responsive */}
        <div className="grid grid-cols-1 md:grid-cols-2 px-3 sm:px-4 lg:px-6 xl:px-3 2xl:px-4 3xl:px-6 py-3 sm:py-4 gap-4 sm:gap-6 lg:gap-8 xl:gap-4 2xl:gap-5 3xl:gap-8 mb-4 sm:mb-6 lg:mb-8 xl:mb-3 2xl:mb-5 3xl:mb-8">
          {/* Upload Sujet */}
          <div className="group">
            <label className="flex items-center gap-2 sm:gap-3 text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg font-bold text-gray-800 mb-2 sm:mb-3 lg:mb-4 xl:mb-1 2xl:mb-2 3xl:mb-4">
              <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-red-500 to-red-600 flex items-center justify-center">
                <FileText className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
              </div>
              <span>Sujet (PDF)</span>
            </label>

            <div className="relative">
              <input
                type="file"
                accept=".pdf"
                onChange={handleSubjectChange}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
              />
              <div className={`
                flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 
                p-4 sm:p-5 lg:p-6 xl:p-3 2xl:p-4 3xl:p-6 border-2 border-dashed rounded-lg sm:rounded-xl lg:rounded-2xl
                text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg transition-all duration-300 
                min-h-[80px] sm:min-h-[100px] lg:min-h-20
                ${subjectFile
                  ? 'border-green-400 bg-gradient-to-r from-green-50 to-emerald-50'
                  : 'border-gray-300 bg-gradient-to-r from-gray-50 to-slate-50 hover:border-gray-400 hover:bg-gradient-to-r hover:from-gray-100 hover:to-slate-100'
                }
                group-hover:scale-[1.01] sm:group-hover:scale-[1.02] group-hover:shadow-lg
              `}>
                <FolderOpen className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 xl:w-5 xl:h-5 2xl:w-6 2xl:h-6 3xl:w-8 3xl:h-8 text-amber-500" />
                <div className="text-center">
                  <div className="font-semibold text-gray-700 text-xs sm:text-sm lg:text-base truncate max-w-[150px] sm:max-w-none">
                    {subjectFile ? subjectFile.name : 'Choisir un fichier'}
                  </div>
                  <div className="text-xs sm:text-sm text-gray-500">
                    {subjectFile ? 'Fichier sélectionné' : 'Aucun fichier choisi'}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Upload Corrigé */}
          <div className="group">
            <label className="flex items-center gap-2 sm:gap-3 text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg font-bold text-gray-800 mb-2 sm:mb-3 lg:mb-4 xl:mb-1 2xl:mb-2 3xl:mb-4">
              <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-red-500 to-red-600 flex items-center justify-center">
                <FileText className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
              </div>
              <span>Corrigé (PDF)</span>
            </label>

            <div className="relative">
              <input
                type="file"
                accept=".pdf"
                onChange={handleCorrectionChange}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
              />
              <div className={`
                flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 
                p-4 sm:p-5 lg:p-6 xl:p-3 2xl:p-4 3xl:p-6 border-2 border-dashed rounded-lg sm:rounded-xl lg:rounded-2xl
                text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg transition-all duration-300 
                min-h-[80px] sm:min-h-[100px] lg:min-h-20
                ${correctionFile
                  ? 'border-green-400 bg-gradient-to-r from-green-50 to-emerald-50'
                  : 'border-gray-300 bg-gradient-to-r from-gray-50 to-slate-50 hover:border-gray-400 hover:bg-gradient-to-r hover:from-gray-100 hover:to-slate-100'
                }
                group-hover:scale-[1.01] sm:group-hover:scale-[1.02] group-hover:shadow-lg
              `}>
                <FolderOpen className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 xl:w-5 xl:h-5 2xl:w-6 2xl:h-6 3xl:w-8 3xl:h-8 text-amber-500" />
                <div className="text-center">
                  <div className="font-semibold text-gray-700 text-xs sm:text-sm lg:text-base truncate max-w-[150px] sm:max-w-none">
                    {correctionFile ? correctionFile.name : 'Choisir un fichier'}
                  </div>
                  <div className="text-xs sm:text-sm text-gray-500">
                    {correctionFile ? 'Fichier sélectionné' : 'Aucun fichier choisi'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Date de l'évaluation - Responsive */}
        <div className="mb-4 sm:mb-6 lg:mb-8 xl:mb-3 2xl:mb-5 3xl:mb-8 px-3 sm:px-4 lg:px-6 xl:px-3 2xl:px-4 3xl:px-6">
          <label className="flex items-center gap-2 sm:gap-3 text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg font-bold text-gray-800 mb-2 sm:mb-3 lg:mb-4 xl:mb-1 2xl:mb-2 3xl:mb-4">
            <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center">
              <Calendar className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
            </div>
            <span className="hidden sm:inline">Date de l'évaluation</span>
            <span className="sm:hidden">Date</span>
          </label>
          <input
            type="date"
            value={evalDate}
            onChange={handleDateValidation}
            min={dateRange.min}
            max={dateRange.max}
            className={`w-full p-3 sm:p-4 xl:p-2 2xl:p-3 3xl:p-4 border-2 rounded-lg sm:rounded-xl text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg 
              transition-all duration-300 focus:outline-none bg-white
              ${dateError ? 'border-red-400 focus:border-red-500' : 'border-gray-200 focus:border-indigo-500'}
              focus:shadow-lg focus:scale-[1.01] sm:focus:scale-[1.02]`}
            required
          />

          {/* Message d'erreur pour date invalide */}
          {dateError && (
            <div className="flex items-center gap-2 mt-2 sm:mt-3 p-2 sm:p-3 bg-gradient-to-r from-yellow-50 to-amber-50 border border-amber-200 rounded-lg sm:rounded-xl">
              <span className="text-amber-700 font-medium text-xs sm:text-sm lg:text-base">
                {dateError}
              </span>
            </div>
          )}
          {!evalDate && !dateError && (
            <div className="flex items-center gap-2 mt-2 sm:mt-3 p-2 sm:p-3 bg-gradient-to-r from-yellow-50 to-amber-50 border border-amber-200 rounded-lg sm:rounded-xl">
              <span className="text-sm sm:text-base lg:text-lg">⚠️</span>
              <span className="text-amber-700 font-medium text-xs sm:text-sm lg:text-base">
                <span className="hidden sm:inline">Veuillez mettre la date de l'évaluation avant de continuer.</span>
                <span className="sm:hidden">Date requise pour continuer</span>
              </span>
            </div>
          )}
        </div>

        {/* Intitulé - Responsive */}
        <div className="mb-4 sm:mb-6 lg:mb-8 xl:mb-3 2xl:mb-5 3xl:mb-8 px-3 sm:px-4 lg:px-6 xl:px-3 2xl:px-4 3xl:px-6">
          <label className="flex items-center gap-2 sm:gap-3 text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg font-bold text-gray-800 mb-2 sm:mb-3 lg:mb-4 xl:mb-1 2xl:mb-2 3xl:mb-4">
            <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-green-500 to-green-600 flex items-center justify-center">
              <FileText className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
            </div>
            <span>Intitulé</span>
          </label>
          <input
            type="text"
            value={niveau ? "Devoir commun" : title}
            onChange={handleTitleChange}
            placeholder="Entrez l'intitulé de l'évaluation..."
            disabled={niveau !== undefined}
            className={`
              w-full p-3 sm:p-4 xl:p-2 2xl:p-3 3xl:p-4 border-2 rounded-lg sm:rounded-xl text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg 
              transition-all duration-300 focus:outline-none
              ${niveau !== undefined
                ? 'bg-gray-100 border-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-white border-gray-200 focus:border-indigo-500 focus:shadow-lg focus:scale-[1.01] sm:focus:scale-[1.02]'}
            `}
          />
          {!niveau && !title && (
            <div className="flex items-center gap-2 mt-2 sm:mt-3 p-2 sm:p-3 bg-gradient-to-r from-yellow-50 to-amber-50 border border-amber-200 rounded-lg sm:rounded-xl">
              <span className="text-sm sm:text-base lg:text-lg">⚠️</span>
              <span className="text-amber-700 font-medium text-xs sm:text-sm lg:text-base">
                <span className="hidden sm:inline">Veuillez mettre le titre avant de continuer.</span>
                <span className="sm:hidden">Titre requis</span>
              </span>
            </div>
          )}
        </div>

        {/* Commentaires - Responsive */}
        <div className="mb-4 sm:mb-6 lg:mb-8 xl:mb-3 2xl:mb-5 3xl:mb-8 px-3 sm:px-4 lg:px-6 xl:px-3 2xl:px-4 3xl:px-6">
          <label className="flex items-center gap-2 sm:gap-3 text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg font-bold text-gray-800 mb-2 sm:mb-3 lg:mb-4 xl:mb-1 2xl:mb-2 3xl:mb-4">
            <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-amber-500 to-orange-500 flex items-center justify-center">
              <MessageSquare className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
            </div>
            <span>Commentaires</span>
          </label>
          <textarea
            value={comments}
            onChange={handleCommentsChange}
            placeholder="Ajoutez vos commentaires ou remarques particulières..."
            rows="3"
            className="w-full p-3 sm:p-4 xl:p-2 2xl:p-3 3xl:p-4 border-2 border-gray-200 rounded-lg sm:rounded-xl text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg 
              transition-all duration-300 focus:outline-none focus:border-indigo-500 focus:shadow-lg 
              resize-vertical bg-white min-h-[80px] sm:min-h-[100px]"
          ></textarea>
        </div>

        {/* Boutons - Responsive */}
        <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 px-3 sm:px-4 lg:px-6 pb-4">
          <button
            type="button"
            onClick={handleBack}
            className="flex items-center justify-center gap-1 sm:gap-2 px-4 sm:px-6 lg:px-8 xl:px-4 2xl:px-5 3xl:px-8 py-2.5 sm:py-3 lg:py-4 xl:py-2 2xl:py-2.5 3xl:py-4 
              bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold 
              rounded-lg sm:rounded-xl text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg
              transition-all duration-300 hover:scale-[1.02] sm:hover:scale-105 hover:shadow-xl 
              uppercase tracking-wide w-full sm:w-auto"
          >
            <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5" />
            <span>Retour</span>
          </button>

          {((niveau || title) && evalDate && !dateError) && (
            <button
              type="button"
              onClick={handleNext}
              className="flex items-center justify-center gap-1 sm:gap-2 px-4 sm:px-6 lg:px-8 xl:px-4 2xl:px-5 3xl:px-8 py-2.5 sm:py-3 lg:py-4 xl:py-2 2xl:py-2.5 3xl:py-4
                bg-gradient-to-r from-green-500 to-emerald-600 text-white font-semibold 
                rounded-lg sm:rounded-xl text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg
                transition-all duration-300 hover:scale-[1.02] sm:hover:scale-105 hover:shadow-xl 
                uppercase tracking-wide w-full sm:w-auto"
            >
              <span>Suivant</span>
              <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default InfoEval;